/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"
import { TeamFragmentDoc } from "./fragment.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

const defaultOptions = {} as const
export type CreateTeamInput = {
  description?: string | null
  id?: string | null
  name: string
}

export type UpdateTeamInput = {
  description?: string | null
  id: string
  name: string
}

export type CreateTeamMutationVariables = Exact<{
  input: Types.CreateTeamInput
}>

export type CreateTeamMutation = {
  __typename: "Mutation"
  team: {
    __typename: "Team"
    createdAt: string
    updatedAt: string
    id: string
    name: string
    description?: string | null
    memberships: Array<{
      __typename: "TeamMember"
      id: string
      role: string
      invitedAt?: string | null
      invitationAcceptedAt?: string | null
      invitationAccepted: boolean
      createdAt: string
      updatedAt: string
      user?: {
        __typename: "User"
        id: string
        name?: string | null
        email: string
        createdAt: string
        updatedAt: string
      } | null
    }>
    projects?: Array<{
      __typename: "Project"
      id: string
      title: string
      phase?: {
        __typename: "ProjectPhase"
        id: string
        value: string
        label: string
      } | null
    }> | null
  }
}

export type UpdateTeamMutationVariables = Exact<{
  teamID: string
  input: Types.UpdateTeamInput
}>

export type UpdateTeamMutation = {
  __typename: "Mutation"
  team: {
    __typename: "Team"
    createdAt: string
    updatedAt: string
    id: string
    name: string
    description?: string | null
    memberships: Array<{
      __typename: "TeamMember"
      id: string
      role: string
      invitedAt?: string | null
      invitationAcceptedAt?: string | null
      invitationAccepted: boolean
      createdAt: string
      updatedAt: string
      user?: {
        __typename: "User"
        id: string
        name?: string | null
        email: string
        createdAt: string
        updatedAt: string
      } | null
    }>
    projects?: Array<{
      __typename: "Project"
      id: string
      title: string
      phase?: {
        __typename: "ProjectPhase"
        id: string
        value: string
        label: string
      } | null
    }> | null
  }
}

export type DeleteTeamMutationVariables = Exact<{
  id: string
}>

export type DeleteTeamMutation = {
  __typename: "Mutation"
  team: { __typename: "DeleteResponse"; success: boolean }
}

export type RestoreTeamMutationVariables = Exact<{
  id: string
}>

export type RestoreTeamMutation = {
  __typename: "Mutation"
  team: {
    __typename: "Team"
    createdAt: string
    updatedAt: string
    id: string
    name: string
    description?: string | null
    memberships: Array<{
      __typename: "TeamMember"
      id: string
      role: string
      invitedAt?: string | null
      invitationAcceptedAt?: string | null
      invitationAccepted: boolean
      createdAt: string
      updatedAt: string
      user?: {
        __typename: "User"
        id: string
        name?: string | null
        email: string
        createdAt: string
        updatedAt: string
      } | null
    }>
    projects?: Array<{
      __typename: "Project"
      id: string
      title: string
      phase?: {
        __typename: "ProjectPhase"
        id: string
        value: string
        label: string
      } | null
    }> | null
  }
}

export const CreateTeamDocument = gql`
  mutation CreateTeam($input: CreateTeamInput!) {
    team: createTeam(input: $input)
      @rest(
        type: "Team"
        method: "POST"
        path: "/project-list/teams"
        bodySerializer: "team"
      ) {
      ...Team
    }
  }
  ${TeamFragmentDoc}
`
export type CreateTeamMutationFn = Apollo.MutationFunction<
  CreateTeamMutation,
  CreateTeamMutationVariables
>

/**
 * __useCreateTeamMutation__
 *
 * To run a mutation, you first call `useCreateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMutation, { data, loading, error }] = useCreateTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTeamMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTeamMutation,
    CreateTeamMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateTeamMutation, CreateTeamMutationVariables>(
    CreateTeamDocument,
    options
  )
}
export type CreateTeamMutationHookResult = ReturnType<
  typeof useCreateTeamMutation
>
export type CreateTeamMutationResult = Apollo.MutationResult<CreateTeamMutation>
export type CreateTeamMutationOptions = Apollo.BaseMutationOptions<
  CreateTeamMutation,
  CreateTeamMutationVariables
>
export const UpdateTeamDocument = gql`
  mutation UpdateTeam($teamID: ID!, $input: UpdateTeamInput!) {
    team: updateTeam(teamID: $teamID, input: $input)
      @rest(
        type: "Team"
        method: "PUT"
        path: "/project-list/teams/{args.teamID}"
        bodySerializer: "team"
      ) {
      ...Team
    }
  }
  ${TeamFragmentDoc}
`
export type UpdateTeamMutationFn = Apollo.MutationFunction<
  UpdateTeamMutation,
  UpdateTeamMutationVariables
>

/**
 * __useUpdateTeamMutation__
 *
 * To run a mutation, you first call `useUpdateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamMutation, { data, loading, error }] = useUpdateTeamMutation({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTeamMutation,
    UpdateTeamMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateTeamMutation, UpdateTeamMutationVariables>(
    UpdateTeamDocument,
    options
  )
}
export type UpdateTeamMutationHookResult = ReturnType<
  typeof useUpdateTeamMutation
>
export type UpdateTeamMutationResult = Apollo.MutationResult<UpdateTeamMutation>
export type UpdateTeamMutationOptions = Apollo.BaseMutationOptions<
  UpdateTeamMutation,
  UpdateTeamMutationVariables
>
export const DeleteTeamDocument = gql`
  mutation DeleteTeam($id: ID!) {
    team: deleteTeam(id: $id)
      @rest(
        type: "DeleteResponse"
        method: "DELETE"
        endpoint: "delete"
        path: "/project-list/teams/{args.id}"
        bodySerializer: "team"
      ) {
      success
    }
  }
`
export type DeleteTeamMutationFn = Apollo.MutationFunction<
  DeleteTeamMutation,
  DeleteTeamMutationVariables
>

/**
 * __useDeleteTeamMutation__
 *
 * To run a mutation, you first call `useDeleteTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeamMutation, { data, loading, error }] = useDeleteTeamMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTeamMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteTeamMutation,
    DeleteTeamMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteTeamMutation, DeleteTeamMutationVariables>(
    DeleteTeamDocument,
    options
  )
}
export type DeleteTeamMutationHookResult = ReturnType<
  typeof useDeleteTeamMutation
>
export type DeleteTeamMutationResult = Apollo.MutationResult<DeleteTeamMutation>
export type DeleteTeamMutationOptions = Apollo.BaseMutationOptions<
  DeleteTeamMutation,
  DeleteTeamMutationVariables
>
export const RestoreTeamDocument = gql`
  mutation RestoreTeam($id: ID!) {
    team: restoreTeam(id: $id)
      @rest(
        type: "Team"
        method: "PUT"
        path: "/project-list/teams/{args.id}/restore"
        bodySerializer: "team"
      ) {
      ...Team
    }
  }
  ${TeamFragmentDoc}
`
export type RestoreTeamMutationFn = Apollo.MutationFunction<
  RestoreTeamMutation,
  RestoreTeamMutationVariables
>

/**
 * __useRestoreTeamMutation__
 *
 * To run a mutation, you first call `useRestoreTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreTeamMutation, { data, loading, error }] = useRestoreTeamMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreTeamMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RestoreTeamMutation,
    RestoreTeamMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<RestoreTeamMutation, RestoreTeamMutationVariables>(
    RestoreTeamDocument,
    options
  )
}
export type RestoreTeamMutationHookResult = ReturnType<
  typeof useRestoreTeamMutation
>
export type RestoreTeamMutationResult =
  Apollo.MutationResult<RestoreTeamMutation>
export type RestoreTeamMutationOptions = Apollo.BaseMutationOptions<
  RestoreTeamMutation,
  RestoreTeamMutationVariables
>
